import { Drawer } from "@mui/material";
import styles from "./index.module.scss";
import { X } from "lucide-react";
import GrayLine from "../../common/components/GrayLine";
import crossIcon from "../../assets/images/crossIconBlue.svg"

interface SideDrawerOverlayProps {
  open: boolean;
  onClose: () => void;
  headerText: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  grayLine?: boolean;
  customClass?: string; // Optional custom class for additional styling
}

const SideDrawerOverlay = ({
  open,
  onClose,
  headerText,
  children,
  footer,
  grayLine,
  customClass = "",
}: SideDrawerOverlayProps) => (
  <Drawer
    anchor="right"
    open={open}
    onClose={onClose}
    PaperProps={{ className: styles.sessionOverlay }}
  >
    <div className={`${styles.overlay} ${customClass} ${open ? styles.open : ""}`}>
      <div className={styles.filterHeader}>
        <>
          {grayLine && (
            <>
              <div className={styles.filter}>{headerText}</div>
              <GrayLine />
            </>)}
        </>
        <div>
          <img src={crossIcon} alt="" className={styles.closeButton} onClick={onClose}  />
        </div>
      </div>
      <div className={styles.filterContainer} style={{ flex: 1, overflowY: "auto" }}>
        {children}
      </div>
      {footer && <div className={styles.buttonRow}>{footer}</div>}
    </div>
  </Drawer>
);

export default SideDrawerOverlay;